import React, { Component } from "react";
import NewsListItem from "./NewsListItem/NewsListItem";
import Pagination from "../Pagination/Pagination";
import ModalWrapper from "../Modal/ModalWrapper";

class NewsListView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      showNewsModal: false,
      newsItemData: {}
    };
  }
  handlePagination = (currentPage, callback) => {
    this.setState(
      {
        currentPage
      },
      () => {
        if (callback && typeof callback === "function") {
          callback();
        }
        this.props.getNewsData({
          from: (currentPage - 1) * this.props.settings.itemsPerPage
        });
      }
    );
  };

  toggleNewsModal = item => {
    this.setState(prevState => {
      return {
        showNewsModal: !prevState.showNewsModal,
        newsItemData: item
      };
    });
  };

  closeModal = () => {
    this.setState({
      showNewsModal: false
    });
  };

  render() {
    const { data, widgetId, widgetInstance, settings } = this.props;

    // Set default localized header title and no news message
    let _headerTitle;
    let _noNewsMessage;
    switch (settings.lang.toLowerCase()) {
      case "fr":
        _headerTitle = "Dernières nouvelles";
        _noNewsMessage = "Revenez bientôt pour les dernières nouvelles";
        break;
      case "es":
        _headerTitle = "Últimas Noticias";
        _noNewsMessage = "Vuelve pronto para las últimas noticias";
        break;
      default:
        _headerTitle = "Latest News";
        _noNewsMessage = "Check back soon for the latest news";
    }

    if (settings.headerTitle && settings.headerTitle.length > 0) {
      _headerTitle = settings.headerTitle;
    }

    if (settings.noNewsMessage && settings.noNewsMessage.length > 0) {
      _noNewsMessage = settings.noNewsMessage;
    }

    return [
      settings.showHeader && (
        <h1 key={`${widgetId}-header`} className={`swg-news__header`}>
          {_headerTitle}
        </h1>
      ),
      data.total > 0 ? (
        data.items.map(newsItem => (
          <NewsListItem
            key={`${widgetId}-${newsItem.entryid}`}
            newsItem={newsItem}
            settings={settings}
            toggleNewsModal={this.toggleNewsModal}
          />
        ))
      ) : (
        <div key={`${widgetId}-no-news`} className={`swg-news__no-news`}>
          {_noNewsMessage}
        </div>
      ),
      settings.usePagination && data.total > settings.itemsPerPage && (
        <Pagination
          key={`${widgetId}-pagination`}
          lang={settings.lang}
          currentPage={this.state.currentPage}
          total={data.total}
          itemsPerPage={settings.itemsPerPage}
          paginationOffset={settings.paginationOffset}
          handlePagination={this.handlePagination}
        />
      ),
      settings.useModal && (
        <ModalWrapper
          key={`${widgetId}-modal`}
          appElement={widgetInstance}
          isOpen={this.state.showNewsModal}
          onRequestClose={this.closeModal}
          backdropColour={settings.backdropColour}
          modalNewsItem={this.state.newsItemData}
          settings={settings}
        />
      )
    ];
  }
}

export default NewsListView;
